import { EditDelegateComponent } from './edit-delegate/edit-delegate.component';
import { AddDelegateComponent } from './add-delegate/add-delegate.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListDelegateComponent } from './list-delegate/list-delegate.component';

export const routesDelegate: Routes = [
    { path: 'delegate', component: ListDelegateComponent },
    { path: 'delegate/add', component: AddDelegateComponent },
    { path: 'delegate/:id/edit', component: EditDelegateComponent },
];

export const DelegateRoutes: ModuleWithProviders = RouterModule.forChild(routesDelegate);
